module.exports = __webpack_public_path__ + "img/slide-2-xxl.26f4323.webp";